import type { GsModalId } from "feature/modal/ModalService";
import type { GsModalConfig } from "feature/modal/ModalService";
import { reactLazyWithRetry } from "@gs/core/utils/reactLazyWithRetry";

export const modalsRegistry = {
  customModalId: {
    modalId: "customModalId",
    Content: reactLazyWithRetry(() => import("feature/modal/CustomModal/CustomModal")),
  },
  unsavedChangesModalId: {
    modalId: "unsavedChangesModalId",
    Content: reactLazyWithRetry(() => import("feature/modal/UnsavedChangesModal/UnsavedChangesModal")),
  },
  flowNodeTasksModalId: {
    modalId: "flowNodeTasksModalId",
    Content: reactLazyWithRetry(() => import("components/routes/OLD_flowsGroup/Flow/Details/FlowVisualizer/NodeVisualizer/NodePreviewFacade/RealNode/FlowNodeTasksModal/FlowNodeTasksModal")),
    query: true,
  },
  massActionDetailsModalId: {
    modalId: "massActionDetailsModalId",
    Content: reactLazyWithRetry(() => import("components/common/UserMassActions/MassActionDetailsModal/MassActionDetailsModalContent")),
  },
  updateEntitiesFromCsvModalId: {
    modalId: "updateEntitiesFromCsvModalId",
    Content: reactLazyWithRetry(() => import("domain/dataSource/modal/UpdateEntitiesFromCsvModal/UpdateEntitiesFromCsvModal")),
    query: true,
  },
  blacklistSourceModalId: {
    modalId: "blacklistSourceModalId",
    Content: reactLazyWithRetry(() => import("domain/dataSource/modal/BlacklistSourceModal/BlacklistSourceModal")),
    query: true,
  },
  linkedinFilterModalId: {
    modalId: "linkedinFilterModalId",
    Content: reactLazyWithRetry(() => import("domain/linkedinFilter/modal/LinkedinFilterModal/LinkedinFilterModal")),
    query: true,
  },
  flowWorkspaceModalId: {
    modalId: "flowWorkspaceModalId",
    Content: reactLazyWithRetry(() => import("domain/flowWorkspace/modal/FlowWorkspaceModal")),
    query: true,
  },
  aiTemplateExampleModalId: {
    modalId: "aiTemplateExampleModalId",
    Content: reactLazyWithRetry(() => import("domain/aiTemplateExample/modal/AiTemplateExampleModal")),
    query: true,
  },
  editMailboxModalId: {
    modalId: "editMailboxModalId",
    Content: reactLazyWithRetry(() => import("domain/mailbox/modal/EditMailboxModal")),
    query: true,
  },
  findContactModalId: {
    modalId: "findContactModalId",
    Content: reactLazyWithRetry(() => import("domain/company/modal/FindContactModal/FindContactModal")),
  },
  createAiTemplateModalId: {
    modalId: "createAiTemplateModalId",
    Content: reactLazyWithRetry(() => import("domain/aiTemplate/modal/CreateAiTemplateModal")),
    query: true,
  },
  aiTemplateFallbackMessageModalId: {
    modalId: "aiTemplateFallbackMessageModalId",
    Content: reactLazyWithRetry(() => import("domain/aiTemplate/modal/AiTemplateFallbackMessageModal")),
    query: true,
  },
  flowModalId: {
    modalId: "flowModalId",
    Content: reactLazyWithRetry(() => import("domain/flow/modal/FlowModal")),
    query: true,
  },
  flowShareModalId: {
    modalId: "flowShareModalId",
    Content: reactLazyWithRetry(() => import("domain/flow/modal/FlowShareModal")),
    query: true,
  },
  webhookTestModalId: {
    modalId: "webhookTestModalId",
    Content: reactLazyWithRetry(() => import("domain/webhook/modal/WebhookTestModal")),
    query: true,
  },
  webhookModalId: {
    modalId: "webhookModalId",
    Content: reactLazyWithRetry(() => import("domain/webhook/modal/WebhookModal")),
    query: true,
  },
  mailboxErrorsModalId: {
    modalId: "mailboxErrorsModalId",
    Content: reactLazyWithRetry(() => import("domain/mailboxError/modal/MailboxErrorsModal")),
    query: true,
  },
  linkedinDataSourceModalId: {
    modalId: "linkedinDataSourceModalId",
    Content: reactLazyWithRetry(() => import("domain/dataSource/modal/LinkedinDataSourceModal/LinkedinDataSourceModal")),
    query: true,
  },
  editDataSourceModalId: {
    modalId: "editDataSourceModalId",
    Content: reactLazyWithRetry(() => import("domain/dataSource/modal/EditDataSourceModal/EditDataSourceModal")),
    query: true,
  },
  createDataSourceFromCsvModalId: {
    modalId: "createDataSourceFromCsvModalId",
    Content: reactLazyWithRetry(() => import("domain/dataSource/modal/CreateDataSourceFromCsvModal/CreateDataSourceFromCsvModal")),
    query: true,
  },
  dataSourceItemsModalId: {
    modalId: "dataSourceItemsModalId",
    Content: reactLazyWithRetry(() => import("domain/dataSourceItem/modal/DataSourceItemsModal/DataSourceItemsModal")),
    query: true,
  },
  leadMassActionForFlowModalId: {
    modalId: "leadMassActionForFlowModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/LeadMassActionForFlowModal/LeadMassActionForFlowModal")),
  },
  leadMassActionForTagModalId: {
    modalId: "leadMassActionForTagModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/LeadMassActionForTagModal/LeadMassActionForTagModal")),
  },
  companyMassActionForTagModalId: {
    modalId: "companyMassActionForTagModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/CompanyMassActionForTagModal/CompanyMassActionForTagModal")),
  },
  leadMassActionForPipelineStageModalId: {
    modalId: "leadMassActionForPipelineStageModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/LeadMassActionForPipelineStageModal/LeadMassActionForPipelineStageModal")),
  },
  companyMassActionForPipelineStageModalId: {
    modalId: "companyMassActionForPipelineStageModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/CompanyMassActionForPipelineStageModal/CompanyMassActionForPipelineStageModal")),
  },
  leadMassActionForListModalId: {
    modalId: "leadMassActionForListModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/LeadMassActionForListModal/LeadMassActionForListModal")),
  },
  companyMassActionForListModalId: {
    modalId: "companyMassActionForListModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/CompanyMassActionForListModal/CompanyMassActionForListModal")),
  },
  leadMassActionDeleteModalId: {
    modalId: "leadMassActionDeleteModalId",
    Content: reactLazyWithRetry(() => import("domain/massAction/modal/LeadMassActionDeleteModal/LeadMassActionDeleteModal")),
  },
  leadCsvExportModalId: {
    modalId: "leadCsvExportModalId",
    Content: reactLazyWithRetry(() => import("domain/lead/modal/LeadCsvExportModal/LeadCsvExportModal")),
  },
  leadWebhookExportModalId: {
    modalId: "leadWebhookExportModalId",
    Content: reactLazyWithRetry(() => import("domain/lead/modal/LeadWebhookExportModal/LeadWebhookExportModal")),
  },
  companyWebhookExportModalId: {
    modalId: "companyWebhookExportModalId",
    Content: reactLazyWithRetry(() => import("domain/company/modal/CompanyWebhookExportModal/CompanyWebhookExportModal")),
  },
  createTasksModalId: {
    modalId: "createTasksModalId",
    Content: reactLazyWithRetry(() => import("domain/taskPipeline/modal/CreateTasksModal/CreateTasksModal")),
  },
  taskBulkCancelModalId: {
    modalId: "taskBulkCancelModalId",
    Content: reactLazyWithRetry(() => import("domain/taskPipeline/modal/TaskBulkCancelModal")),
  },
  taskBulkCompleteModalId: {
    modalId: "taskBulkCompleteModalId",
    Content: reactLazyWithRetry(() => import("domain/taskPipeline/modal/TaskBulkCompleteModal")),
  },
  taskBulkAssignModalId: {
    modalId: "taskBulkAssignModalId",
    Content: reactLazyWithRetry(() => import("domain/taskPipeline/modal/TaskBulkAssignModal")),
  },
  viewAutoTaskDetailsModalId: {
    modalId: "viewAutoTaskDetailsModalId",
    Content: reactLazyWithRetry(() => import("domain/taskPipeline/modal/ViewAutoTaskDetailsModal/ViewAutoTaskDetailsModal")),
    query: true,
  },
  selectAttachmentModalId: {
    modalId: "selectAttachmentModalId",
    Content: reactLazyWithRetry(() => import("domain/attachment/modal/SelectAttachmentModal/SelectAttachmentModal")),
  },
  newSubscriptionModalId: {
    modalId: "newSubscriptionModalId",
    Content: reactLazyWithRetry(() => import("feature/billing/modal/NewSubscriptionModal")),
    query: true,
  },
  addLicensesModalId: {
    modalId: "addLicensesModalId",
    Content: reactLazyWithRetry(() => import("feature/billing/modal/AddLicensesModal")),
    query: true,
  },
  senderProfileModalId: {
    modalId: "senderProfileModalId",
    Content: reactLazyWithRetry(() => import("domain/senderProfile/modal/SenderProfileModal")),
    query: true,
  },
  senderProfileScheduleModalId: {
    modalId: "senderProfileScheduleModalId",
    Content: reactLazyWithRetry(() => import("domain/senderProfile/modal/SenderProfileScheduleModal")),
    query: true,
  },
  tagModalId: {
    modalId: "tagModalId",
    Content: reactLazyWithRetry(() => import("domain/tag/modal/TagModal")),
    query: true,
  },
  leadBlacklistModalId: {
    modalId: "leadBlacklistModalId",
    Content: reactLazyWithRetry(() => import("domain/leadBlacklist/modal/LeadBlacklistModal")),
    query: true,
  },
  companyBlacklistModalId: {
    modalId: "companyBlacklistModalId",
    Content: reactLazyWithRetry(() => import("domain/companyBlacklist/modal/CompanyBlacklistModal")),
    query: true,
  },
  customFieldModalId: {
    modalId: "customFieldModalId",
    Content: reactLazyWithRetry(() => import("domain/customField/modal/CustomFieldModal")),
    query: true,
  },
  shareGologinModalId: {
    modalId: "shareGologinModalId",
    Content: reactLazyWithRetry(() => import("domain/linkedinBrowser/modal/ShareGologinModal")),
    query: true,
  },
  linkedinBrowserUpdateProxyModalId: {
    modalId: "linkedinBrowserUpdateProxyModalId",
    Content: reactLazyWithRetry(() => import("domain/linkedinBrowser/modal/LinkedinBrowserUpdateProxyModal")),
    query: true,
  },
  removeLicensesModalId: {
    modalId: "removeLicensesModalId",
    Content: reactLazyWithRetry(() => import("feature/billing/modal/RemoveLicensesModal")),
    query: true,
  },
  mirrorProfilesModalId: {
    modalId: "mirrorProfilesModalId",
    Content: reactLazyWithRetry(() => import("components/routes/SenderProfileGroup/Sidebar/MirrorProfilesModal")),
    query: true,
  },
  changePlanModalId: {
    modalId: "changePlanModalId",
    Content: reactLazyWithRetry(() => import("feature/billing/modal/ChangePlanModal")),
    query: true,
  },
  teamLimitReachedModalId: {
    modalId: "teamLimitReachedModalId",
    Content: reactLazyWithRetry(() => import("feature/billing/modal/TeamLimitReachedModal/TeamLimitReachedModal")),
  },
  cancelSubscriptionModalId: {
    modalId: "cancelSubscriptionModalId",
    Content: reactLazyWithRetry(() => import("feature/billing/modal/CancelSubscriptionModal")),
  },
  createTeamModalId: {
    modalId: "createTeamModalId",
    Content: reactLazyWithRetry(() => import("domain/team/modal/CreateTeamModal")),
    query: true,
  },
  editTeamModalId: {
    modalId: "editTeamModalId",
    Content: reactLazyWithRetry(() => import("domain/team/modal/EditTeamModal")),
    query: true,
  },
  teamChangeOwnerModalId: {
    modalId: "teamChangeOwnerModalId",
    Content: reactLazyWithRetry(() => import("domain/team/modal/TeamChangeOwnerModal")),
    query: true,
  },
  teamChangeSubscriptionModalId: {
    modalId: "teamChangeSubscriptionModalId",
    Content: reactLazyWithRetry(() => import("domain/team/modal/TeamChangeSubscriptionModal")),
    query: true,
  },
  messengerSenderProfileVisibilityModalId: {
    modalId: "messengerSenderProfileVisibilityModalId",
    Content: reactLazyWithRetry(() => import("components/routes/Messenger/SenderProfilesBar/MessengerSenderProfileVisibilityModal")),
    query: true,
  },
  leadEditBaseInformationModalId: {
    modalId: "leadEditBaseInformationModalId",
    Content: reactLazyWithRetry(() => import("domain/lead/modal/LeadEditBaseInformationModal/LeadEditBaseInformationModal")),
    query: true,
  },
  companyEditBaseInformationModalId: {
    modalId: "companyEditBaseInformationModalId",
    Content: reactLazyWithRetry(() => import("domain/company/modal/CompanyEditBaseInformationModal/CompanyEditBaseInformationModal")),
    query: true,
  },
  deleteFlowNodeModalId: {
    modalId: "deleteFlowNodeModalId",
    Content: reactLazyWithRetry(() => import("domain/flowNode/modal/DeleteFlowNodeModal")),
  },
  updateFlowNodeModalId: {
    modalId: "updateFlowNodeModalId",
    Content: reactLazyWithRetry(() => import("domain/flowNode/modal/UpdateFlowNodeModal")),
  },
  changeEmailModalId: {
    modalId: "changeEmailModalId",
    Content: reactLazyWithRetry(() => import("domain/user/modal/ChangeEmailModal")),
    query: true,
  },
  changePasswordModalId: {
    modalId: "changePasswordModalId",
    Content: reactLazyWithRetry(() => import("domain/user/modal/ChangePasswordModal")),
    query: true,
  },
  leadEditAboutModalId: {
    modalId: "leadEditAboutModalId",
    Content: reactLazyWithRetry(() => import("domain/lead/modal/LeadEditAboutModal/LeadEditAboutModal")),
    query: true,
  },
  companyEditAboutModalId: {
    modalId: "companyEditAboutModalId",
    Content: reactLazyWithRetry(() => import("domain/company/modal/CompanyEditAboutModal/CompanyEditAboutModal")),
    query: true,
  },
  leadEditContactsModalId: {
    modalId: "leadEditContactsModalId",
    Content: reactLazyWithRetry(() => import("domain/lead/modal/LeadEditContactsModal/LeadEditContactsModal")),
    query: true,
  },
  companyEditContactsModalId: {
    modalId: "companyEditContactsModalId",
    Content: reactLazyWithRetry(() => import("domain/company/modal/CompanyEditContactsModal/CompanyEditContactsModal")),
    query: true,
  },
  createApyKeyModalId: {
    modalId: "createApyKeyModalId",
    Content: reactLazyWithRetry(() => import("domain/jwtToken/modal/CreateApyKeyModal")),
    query: true,
  },
} as const satisfies {
  [K in GsModalId]: GsModalConfig<K>
};
